import React, { useEffect } from 'react';
import { HashRouter as Router, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import esES from 'antd/locale/es_ES';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { LoginProvider } from './context/loginContext';
import { PermissionsProvider } from './context/permissionsContext';
import Login from './pages/login/login';
import ProtectedRoute from './pages/protectedRoute/protectedRoute';
import PermissionRoute from './pages/protectedRoute/permissionRoute';
import HomeAdministrador from './pages/administrador/home/homeAdministrador';
import Clientes from './pages/administrador/clientes/clientes';
import Productos from './pages/administrador/productos/productos';
import Conceptos from './pages/administrador/conceptos/conceptos';
import Exportacion from './pages/administrador/exportacion/exportacion';
import Importacion from './pages/administrador/importacion/importacion';
import ServiciosAcordados from './pages/administrador/serviciosAcordados/serviciosAcordados';
import CotizacionesEliminadas from './pages/administrador/cotizacionesEliminadas/cotizacionesEliminadas';
import Usuarios from './pages/administrador/usuarios/usuarios';
import Roles from './pages/administrador/roles/roles';
import Curriculums from './pages/administrador/curriculums/curriculums';
import Localidades from './pages/administrador/localidades/localidades';
import AgendaReuniones from './pages/administrador/agendaReuniones/agendaReuniones';
import MainLayout from './pages/layout/mainLayout';
import { PANEL_ROLES } from './constants/roles';

const RootRoute = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/login', { replace: true });
  }, [navigate]);
  return null;
};

const withPanel = (modulo, element) => (
  <ProtectedRoute allowedRoles={PANEL_ROLES}>
    <PermissionRoute module={modulo} action="ver">
      <MainLayout>{element}</MainLayout>
    </PermissionRoute>
  </ProtectedRoute>
);

function App() {
  dayjs.locale('es');

  return (
    <ConfigProvider
      locale={esES}
      componentSize="small"
      theme={{
        algorithm: [theme.defaultAlgorithm, theme.compactAlgorithm],
        token: {
          colorPrimary: '#198039',
          colorBgBase: '#f3faf6',
          colorBgLayout: '#f3faf6',
          colorBgContainer: '#ffffff',
          colorText: '#1f2937',
          colorBorder: '#d8e8dc',
          colorLink: '#198039',
        },
        components: {
          Menu: {
            itemSelectedColor: '#198039',
            itemSelectedBg: 'rgba(25, 128, 57, 0.12)',
            itemHoverBg: 'rgba(25, 128, 57, 0.06)',
            itemActiveBg: 'rgba(25, 128, 57, 0.1)',
          },
          Layout: {
            headerBg: '#ffffff',
            bodyBg: '#f3faf6',
            siderBg: '#ffffff',
          },
        },
      }}
    >
      <LoginProvider>
        <PermissionsProvider>
          <Router>
            <Routes>
              <Route path="/" element={<RootRoute />} />
              <Route path="/login" element={<Login />} />
              <Route path="/administrador/home" element={withPanel('inicio', <HomeAdministrador />)} />
              <Route path="/administrador/clientes" element={withPanel('clientes', <Clientes />)} />
              <Route path="/administrador/productos" element={withPanel('productos', <Productos />)} />
              <Route path="/administrador/conceptos" element={withPanel('conceptos', <Conceptos />)} />
              <Route path="/administrador/exportacion" element={withPanel('exportacion', <Exportacion />)} />
              <Route path="/administrador/importacion" element={withPanel('importacion', <Importacion />)} />
              <Route
                path="/administrador/servicios-acordados"
                element={withPanel('servicios_acordados', <ServiciosAcordados />)}
              />
              <Route
                path="/administrador/cotizaciones-eliminadas"
                element={withPanel('cotizaciones_eliminadas', <CotizacionesEliminadas />)}
              />
              <Route
                path="/administrador/agenda-reuniones"
                element={withPanel('agenda_reuniones', <AgendaReuniones />)}
              />
              <Route path="/administrador/curriculums" element={withPanel('curriculums', <Curriculums />)} />
              <Route path="/administrador/localidades" element={withPanel('localidades', <Localidades />)} />
              <Route path="/administrador/usuarios" element={withPanel('usuarios', <Usuarios />)} />
              <Route path="/administrador/roles" element={withPanel('usuarios', <Roles />)} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Router>
        </PermissionsProvider>
      </LoginProvider>
    </ConfigProvider>
  );
}

export default App;
